import { render, staticRenderFns } from "./invoice-cost-breakdown.vue?vue&type=template&id=8bb67d86&scoped=true"
import script from "./invoice-cost-breakdown.vue?vue&type=script&lang=js"
export * from "./invoice-cost-breakdown.vue?vue&type=script&lang=js"
import style0 from "./invoice-cost-breakdown.vue?vue&type=style&index=0&id=8bb67d86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb67d86",
  null
  
)

export default component.exports